module.exports = __webpack_public_path__ + "html/wave-header_0dfa4dac7930f5a834a05e790e6aae03.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 153